var map = {
	"./1.jpeg": 52,
	"./2.jpeg": 53,
	"./3.jpeg": 54,
	"./logo-footer.png": 39,
	"./logo.png": 38,
	"./mok.png": 109,
	"./pp.jpg": 51,
	"./slide.png": 110,
	"./teacher.png": 111,
	"./video-1.png": 55,
	"./video-2.png": 56,
	"./video-3.png": 57
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 108;